import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { constants, links } from 'common/helpers'
import { intlMessageShape } from 'sb-react-intl'

import ResubscribeButton from 'components/buttons/ResubscribeButton/ResubscribeButton'


const ResubscribeNowButton = (props) => {
  const {
    className, placement, onClick, resubscribeCode,
    fullWidth, title, uppercase,
  } = props

  const handleClick = useCallback((event) => {
    actions.models.subscription.resubscribe({ popup: placement, resubscribeCode })
      .then(({ premiumProduct }) => {
        if (premiumProduct) {
          actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
            item: premiumProduct,
          })
        }
        else {
          actions.models.modals.open(constants.modals.resubscribe.ResubscribeSuccess)
        }
      }, ({ isRedirected }) => {
        if (!isRedirected) {
          actions.models.router.push(links.subscribe)
        }
      })

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }, [ placement, onClick, resubscribeCode ])

  return (
    <ResubscribeButton
      className={className}
      title={title}
      uppercase={uppercase}
      to={null}
      fullWidth={fullWidth}
      placement={placement}
      onClick={handleClick}
    />
  )
}

ResubscribeNowButton.propTypes = {
  fullWidth: PropTypes.bool,
  uppercase: PropTypes.bool,
  title: PropTypes.shape(intlMessageShape),
  placement: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  resubscribeCode: PropTypes.string,
}


export default ResubscribeNowButton
